// Locations Page
export default function Locations() { return <div><h1 className="text-4xl font-bold text-center py-20">Our Locations</h1><p className="text-center">Find our venues across Enfield and Barnet.</p></div>; }